<script>
	export let image = '';
	export let name = '';
	export let labresult = '';
	let notFound = false;
</script>

<div class="relative flex w-full h-full overflow-hidden">
	<img
		alt="gallery"
		class="absolute object-cover object-center w-full h-full overflow-hidden rounded-xl"
		src={image} />
	<div
		class="z-10 flex flex-col items-center justify-center w-full h-full px-8 subpixel-antialiased text-center transition duration-150 bg-gray-100 border-4 border-gray-200 rounded-lg shadow-inner opacity-0 cursor-pointer hover:opacity-100">
		{#if labresult}
			<a href={labresult} label="Download {name}'s COA">
				<h2
					class="text-sm font-medium tracking-widest text-green-500 title-font">
					<p>C.O.A.</p>
				</h2>
				<h1
					class="text-lg font-medium leading-tight tracking-tight text-gray-900 b-8 title-font">
					{name}
				</h1>
				<div class="m-4" />
				<div class="flex flex-row items-center justify-center">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						class="w-12 h-12 text-gray-400"
						stroke="currentColor">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
					</svg>
				</div>
				<span class="text-sm">Download</span>
			</a>
		{:else}
			<div
				class="flex flex-col items-center justify-center w-full text-sm">
				<h1 class="text-lg">☹</h1>
				<div class="h-2" />
				<h2 class="w-full text-base text-center">
					COA
					<b>Not Found</b>
				</h2>
				<div class="h-2" />
				<span class="text-sm">Email
					<b>Jose@JoseAA.com</b>
					for help accessing this COA</span>
			</div>
		{/if}
	</div>
</div>
